import { EpimsBaseEntityDto } from './epim-base.dto';
export class EngagementDriverDto extends EpimsBaseEntityDto {

    EngagementDriverId: string;

    EngagementDriverName: string;

   

}